﻿import { FormArray, FormControl, FormGroup, ValidationErrors } from '@angular/forms';

export class CustomValidators {
    static vaildPhone(c: FormControl): ValidationErrors {
        const phone = c.value;
        var reg = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
        var isValid = true;
        const message = {
            'vaildPhone': {
                'message': 'Should be valid phone.'
            }
        };
        if (reg.test(phone)) {
            isValid = true;
        }
        else {
            isValid = false;
        }
        return isValid ? null : message;
    }
    
    static noZeroLength(c: FormControl): ValidationErrors
    {
        const val = c.value;

        const IsValid = val ? (!val.length ? true : 
                val.length > 0 ? true : false): false;

        const message = {
            'noZeroLength': {
                'message': 'Invalid'
            }
        };

        return IsValid ? null : message;        
    }
}
